import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AvdbPricingResponse } from '../models/avdb-pricing/avdb-pricing-response.model';
import { LocaleService } from './locale.service';

const apiURL = `${environment.flyLegacyUrl}/api/`;
const avdbPricingURL = `${apiURL}avdb-pricing/`;

@Injectable()
export class DatabasePricingService {
  constructor(
    private readonly http: HttpClient,
    private readonly localeService: LocaleService
  ) {}

  getAvdbPricingForDevices(
    deviceIDs: number[],
    avdbProductKey?: string,
    includeAvdbsWithoutPrice?: boolean
  ): Observable<AvdbPricingResponse> {
    const params: Record<string, any> = {};
    params.deviceIDs = deviceIDs;
    if (avdbProductKey != null) {
      params.filterProductKeys = avdbProductKey;
    }
    if (includeAvdbsWithoutPrice != null) {
      params.includeAvdbsWithoutPrice = includeAvdbsWithoutPrice;
    }
    return this.pricingRequest(params);
  }

  getAvdbPricingForAircraft(
    aircraftID: string,
    avdbProductKey?: string,
    includeAvdbsWithoutPrice?: boolean
  ): Observable<AvdbPricingResponse> {
    const params: Record<string, any> = {};
    params.aircraftID = aircraftID;
    if (avdbProductKey != null) {
      params.filterProductKeys = avdbProductKey;
    }
    if (includeAvdbsWithoutPrice != null) {
      params.includeAvdbsWithoutPrice = includeAvdbsWithoutPrice;
    }
    return this.pricingRequest(params);
  }

  getAvdbPricingForAircraftAndPortable(
    aircraftID: string,
    portableDeviceID?: number,
    includeAvdbsWithoutPrice?: boolean
  ): Observable<AvdbPricingResponse> {
    const params: Record<string, any> = {};
    params.aircraftID = aircraftID;
    if (portableDeviceID != null) {
      params.deviceIDs = portableDeviceID;
    }
    if (includeAvdbsWithoutPrice != null) {
      params.includeAvdbsWithoutPrice = includeAvdbsWithoutPrice;
    }
    return this.pricingRequest(params);
  }

  private pricingRequest(params: Record<string, any>): Observable<AvdbPricingResponse> {
    return this.localeService.getSelectedLocale().pipe(
      mergeMap((locale) => {
        return this.http.get<AvdbPricingResponse>(`${avdbPricingURL}${locale.wpcLocale}/`, { params }).pipe(
          map((res) => {
            res.params = params;
            return res;
          }),
          tap((response) => this.linkResponse(response))
        );
      })
    );
  }

  private linkResponse(response: AvdbPricingResponse): void {
    // TODO: Find a better way to handle this

    for (const device of response.devices) {
      for (const avdbType of device.avdbProductTypes) {
        for (const product of avdbType.products) {
          product.productType = avdbType;
        }
      }

      for (const bundle of device.bundles) {
        bundle.deviceID = device.id;
        bundle.deviceModelID = device.modelID;
      }
    }
  }
}
